import React from 'react';
import { Spinner } from '@fluentui/react-components';
import { loading } from './OwaHeaderAppLauncherContent.scss';

export default function OwaHeaderAppLauncherLoading(): React.JSX.Element {
    return <Spinner size="medium" className={loading} />;
}
